import './App.css';
import UploadedFiles from './pages/TranscriptioFIles';
import { Route, Routes } from 'react-router-dom';
import UploadFile from './pages/UploadFile';
import HomePage from './pages/Home';
import Transcription from './pages/Transcription';
import LiveSTT from './pages/LiveSTT';
import Grammetical from './pages/Grammetical';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cleanup/:id" element={<Grammetical />} />
        <Route path="/transcript/:id/:view" element={<Transcription />} />
        <Route path="/live" element={<LiveSTT />} />
      </Routes>
    </div>
  );
}

export default App;
